import type { AvatarId } from '@/types/wire';

import brown from './avatars/brown.png';
import cap from './avatars/cap.png';
import glasses from './avatars/glasses.png';
import pink from './avatars/pink.png';
import kaLogo from './ka-logo.png';
import kaLogoWhite from './ka-logo-white.png';
import kkWordmarkWhite from './kk-logo-word-white.png';

/** Copied from apps/mobile/assets/avatars; @kk/ui AvatarDisc takes `{ uri }` on web. */
export const avatarUrls: Record<AvatarId, string> = { glasses, pink, brown, cap };

/**
 * The Kredit Academy logo at the sidebar foot — docs/handoff/design/assets/ka-logo-full-color.png, scaled to 240×123
 * (drawn 22px tall). Fingerprinted by Vite, so a new logo is a new URL with no cache to outlive.
 */
export const kaLogoUrl: string = kaLogo;

/**
 * The two white-knockout files, for the turquoise panel on sign-in. Both are the DELIVERED artwork
 * (`docs/handoff/design/assets/`), copied rather than redrawn — Evan, 2026-09-22: *"Place the artwork; never
 * retype it."* The endorsement is a lockup, and a lockup typeset in HTML is a different mark.
 *
 * There is no white version of the rounded kk tile, so the panel carries the WORDMARK alone.
 */
export const kkWordmarkWhiteUrl: string = kkWordmarkWhite;
export const kaLogoWhiteUrl: string = kaLogoWhite;
